import { Competition } from '@brg/api';
import {
  COMPETITION_APPLY_PROJECT_TYPE,
  COMPETITION_MOMENT_APPLY_PROJECT_TYPE,
  COMPETITION_TYPE,
  STATUSES,
} from '_competition/const';

export const isPreRegistrationCompetitionType = (competition?: Competition): boolean => {
  const competitionType = competition?.competitionType;
  if (Number.isInteger(competitionType)) {
    return competitionType === COMPETITION_TYPE.PreRegistration;
  }
  //@ts-ignore
  return !!competition?.isPreRegistration;
};

export const isApprovedPreRegistrationParticipant = (competition?: Competition, accountId?: string): boolean =>
  !!competition?.participantAccountIds?.includes(accountId);

export const isPendingPreRegistrationApproval = (competition?: Competition, accountId?: string): boolean =>
  //@ts-ignore
  !!competition?.pendingParticipantsIds?.includes(accountId);

export const hasSubmittedPreRegistrationForm = (competition?: Competition, accountId?: string): boolean =>
  isApprovedPreRegistrationParticipant(competition, accountId) || isPendingPreRegistrationApproval(competition, accountId);

export const requiresModeratorApproval = (competition?: Competition): boolean =>
  //@ts-ignore
  competition?.applyProjectType === COMPETITION_APPLY_PROJECT_TYPE.ApprovedOnly;

export const opensProjectSubmissionAtAppointedTime = (competition?: Competition): boolean =>
  //@ts-ignore
  competition?.applyProjectMoment === COMPETITION_MOMENT_APPLY_PROJECT_TYPE.AppointedTime;

export const getProjectSubmissionStartDate = (competition?: Competition): Date | undefined => {
  //@ts-ignore
  const value = competition?.applyProjectStart;
  return value ? new Date(value) : undefined;
};

export const getPreRegistrationDeadline = (competition?: Competition): Date | undefined => {
  //@ts-ignore
  const value = competition?.formAnswerApplyEnd;
  return value ? new Date(value) : undefined;
};

export const isProjectSubmissionBeforeStart = (competition?: Competition, accountId?: string): boolean => {
  if (!hasSubmittedPreRegistrationForm(competition, accountId) || !opensProjectSubmissionAtAppointedTime(competition)) {
    return false;
  }
  const startDate = getProjectSubmissionStartDate(competition);
  return !!startDate && new Date() < startDate;
};

export const isAwaitingModeratorApproval = (competition?: Competition, accountId?: string): boolean =>
  requiresModeratorApproval(competition)
  && isPendingPreRegistrationApproval(competition, accountId);

export const isPreRegistrationDeadlinePassed = (competition?: Competition, accountId?: string): boolean => {
  if (hasSubmittedPreRegistrationForm(competition, accountId)) {
    return false;
  }
  const deadline = getPreRegistrationDeadline(competition);
  return !!deadline && new Date() > deadline;
};

export const isProjectSubmissionDeadlinePassed = (competition?: Competition, accountId?: string): boolean => {
  if (!hasSubmittedPreRegistrationForm(competition, accountId)) {
    return false;
  }
  if (competition?.status === STATUSES.Completed
    || competition?.status === STATUSES.Archived
    || competition?.status === STATUSES.Voting
    || competition?.status === STATUSES.Summarizing) {
    return true;
  }
  return !!competition?.endDate && new Date() > new Date(competition.endDate);
};

export const formatDateTime = (date?: Date): string => {
  if (!date) {
    return '';
  }
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(date.getUTCDate())}.${pad(date.getUTCMonth() + 1)}.${date.getUTCFullYear()} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`;
};
import { Competition } from '@brg/api';
import {
  COMPETITION_APPLY_PROJECT_TYPE,
  COMPETITION_MOMENT_APPLY_PROJECT_TYPE,
  COMPETITION_TYPE,
  STATUSES,
} from '_competition/const';

export const isPreRegistrationCompetitionType = (competition?: Competition): boolean => {
  const competitionType = competition?.competitionType;
  if (Number.isInteger(competitionType)) {
    return competitionType === COMPETITION_TYPE.PreRegistration;
  }
  //@ts-ignore
  return !!competition?.isPreRegistration;
};

export const isApprovedPreRegistrationParticipant = (competition?: Competition, accountId?: string): boolean =>
  !!competition?.participantAccountIds?.includes(accountId);

export const isPendingPreRegistrationApproval = (competition?: Competition, accountId?: string): boolean =>
  //@ts-ignore
  !!competition?.pendingParticipantsIds?.includes(accountId);

export const hasSubmittedPreRegistrationForm = (competition?: Competition, accountId?: string): boolean =>
  isApprovedPreRegistrationParticipant(competition, accountId) || isPendingPreRegistrationApproval(competition, accountId);

export const requiresModeratorApproval = (competition?: Competition): boolean =>
  //@ts-ignore
  competition?.applyProjectType === COMPETITION_APPLY_PROJECT_TYPE.ApprovedOnly;

export const opensProjectSubmissionAtAppointedTime = (competition?: Competition): boolean =>
  //@ts-ignore
  competition?.applyProjectMoment === COMPETITION_MOMENT_APPLY_PROJECT_TYPE.AppointedTime;

export const getProjectSubmissionStartDate = (competition?: Competition): Date | undefined => {
  //@ts-ignore
  const value = competition?.applyProjectStart;
  return value ? new Date(value) : undefined;
};

export const getPreRegistrationDeadline = (competition?: Competition): Date | undefined => {
  //@ts-ignore
  const value = competition?.formAnswerApplyEnd;
  return value ? new Date(value) : undefined;
};

export const isProjectSubmissionBeforeStart = (competition?: Competition, accountId?: string): boolean => {
  if (!hasSubmittedPreRegistrationForm(competition, accountId) || !opensProjectSubmissionAtAppointedTime(competition)) {
    return false;
  }
  const startDate = getProjectSubmissionStartDate(competition);
  return !!startDate && new Date() < startDate;
};

export const isAwaitingModeratorApproval = (competition?: Competition, accountId?: string): boolean =>
  requiresModeratorApproval(competition)
  && isPendingPreRegistrationApproval(competition, accountId);

export const isPreRegistrationDeadlinePassed = (competition?: Competition, accountId?: string): boolean => {
  if (hasSubmittedPreRegistrationForm(competition, accountId)) {
    return false;
  }
  const deadline = getPreRegistrationDeadline(competition);
  return !!deadline && new Date() > deadline;
};

export const isProjectSubmissionDeadlinePassed = (competition?: Competition, accountId?: string): boolean => {
  if (!hasSubmittedPreRegistrationForm(competition, accountId)) {
    return false;
  }
  if (competition?.status === STATUSES.Completed
    || competition?.status === STATUSES.Archived
    || competition?.status === STATUSES.Voting
    || competition?.status === STATUSES.Summarizing) {
    return true;
  }
  return !!competition?.endDate && new Date() > new Date(competition.endDate);
};

export const formatDateTime = (date?: Date): string => {
  if (!date) {
    return '';
  }
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(date.getUTCDate())}.${pad(date.getUTCMonth() + 1)}.${date.getUTCFullYear()} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`;
};
